// eslint-disable-next-line import/prefer-default-export
export const LISTEN_CALENDAR = 'listen-calendar';
